<div class="container-fluid">
    <div class="row mt-5 form-group">
        <div class="modalbox error col-sm-12 center animate"
            [ngClass]="{'error':data && !data.success , 'success':data && data.success} ">
            <div class="icon">
                <span class="glyphicon ">
                    <i class='fa fa-check' *ngIf="data && data.success"></i>
                    <i class='fa fa-question-circle' *ngIf="data && !data.success"></i>
                </span>
            </div>     
            <!--/.icon-->
            <h1 id="success_payment_title" style="margin-top: .5rem !important;"> {{data && data.title}} </h1>
            <p class="text-center"> <span id="success_payment_info"> {{data && data.message}} </span>
                <!-- <br> <span id="redirect_warning">
                    Your will be redirected to
                </span>
                <a (click)="goToBase()" style="cursor: pointer;" id="url">
                    https://www.tallite.com/career/jobs  
                </a> <span id="in">in </span>
                <span id="timer"> {{timer}} </span>s -->
            </p>

        </div>
        <div class="col-md-12 text-right">
            <button style="min-width: 100px;" class="  blob-btn-cancel ml-auto btn mx-1 mx-1 tallite-action"
                (click)="goToBase()">
                <ng-container *ngIf="data &&data.negative_button">
                    {{data.negative_button | translate}}
                </ng-container>
                <ng-container *ngIf="data &&!data.negative_button">
                    {{'BTN.close' |translate}}
                </ng-container>

                <span class="blob-btn-cancel__inner">
                    <span class="blob-btn-cancel__blobs">
                        <span class="blob-btn-cancel__blob"></span>
                        <span class="blob-btn-cancel__blob"></span>
                        <span class="blob-btn-cancel__blob"></span>
                        <span class="blob-btn-cancel__blob"></span>
                    </span>
                </span>
            </button>
            <button style="min-width: 100px;" *ngIf="data && data.url" class="blob-btn  btn   mx-1  tallite-action"
                type="submit" (click)="goToLogin()">
                {{'Login' |translate}}
                <span class="blob-btn__inner">
                    <span class="blob-btn__blobs">
                        <span class="blob-btn__blob"></span>
                        <span class="blob-btn__blob"></span>
                        <span class="blob-btn__blob"></span>
                        <span class="blob-btn__blob"></span>
                    </span>
                </span>
            </button>
        </div>
        <!--/.success-->
    </div>

</div>